import React from 'react';
import {FormHelperText} from '@material-ui/core';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from './fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';

const Owner = props => {
    const [owner, setOwner] = useFieldData('owner_operator_or_master');
    const {schema, initialValues} = bootstrapOldForm('Ownership', fields);
    const showWarning = owner === true || owner === 'true';

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Vessel Owner
            </Typography>
            <AutoField
                field={fields.owner_operator_or_master}
                name='owner_operator_or_master'
                onChange={e => setOwner(e.target.value === 'true')}
            />
            {showWarning && (
                <FormHelperText error>
                    Great! Just to give you a heads up that when you finish
                    adding this CG-719s you will need to add either your Title
                    for the vessel, the State Registration if State registered,
                    the Certificate of Documentation if registered with the U.S.
                    Coast Guard or the Bill of Sale as proof of ownership to
                    Documents.
                </FormHelperText>
            )}
            {props.children}
        </Section>
    );
};

export default Owner;
